import React, { useState, useCallback, useEffect, useContext } from 'react';
import { shouldFetchData } from '../../../data/fetchStatus';
import { status } from '../../../data/fetchStatus';
import Notation from '../../Shared/Notation';
import {
  waitingStatusClasses,
  waitingStatusDetail,
} from '../../../data/statusDefinitions';
import { quoteStatus } from '../../../data/quoteStatus';
import QuoteElementUserRdvModal from './QuoteElementUserRdvModal.js/QuoteElementUserRdvModal';
import QuoteElementExpertDetails from './QuoteElementExpertDetails';
import { formatDate } from '../../../utils/date';
import QuoteElementUserMissionModal from './QuoteElementUserMissionModal/QuoteElementUserMissionModal';
import Services from '../../Services/services';
import { ClientContext } from '../../Contexts/contexts';
import useToast from '../../Toasts/useToast';
import {
  ToastHeaders,
  ToastThemes,
  ToastMessages,
} from '../../Toasts/ToastOptions/toastOptions';

function QuoteElementUser(props) {
  const clientContext = useContext(ClientContext);
  const enqueueToast = useToast();

  const [expert, setExpert] = useState({});
  const [expertFetched, setExpertFetched] = useState(status.DEFAULT);

  const fetchExpert = useCallback(async () => {
    if (
      props?.clientExpertRelation?.expertId === undefined ||
      expertFetched === status.FETCHED
    )
      return;

    setExpertFetched(status.FETCHED);

    try {
      let expertData = await Services.profileService.expertByID(
        props?.clientExpertRelation?.expertId
      );

      expertData = expertData.length > 0 ? expertData[0] : expertData;

      let cabinetData = await Services.cabinetService.cabinetByID(
        expertData?.cabinetId
      );

      cabinetData = cabinetData.length > 0 ? cabinetData[0] : cabinetData;

      const locationData = await Services.locationService.locationByID(
        cabinetData?.locationId
      );

      const cabinet = {
        cabinet: {
          ...cabinetData,
          location: locationData,
        },
      };

      expertData = { ...expertData, ...cabinet };

      const ratingData = await Services.ratingService.ratingByID(
        expertData?.ratingId
      );

      expertData.rating = ratingData;

      const userData = await Services.userService.userByID(expertData?.userId);

      expertData.user = userData;

      setExpert(expertData);
    } catch (error) {
      enqueueToast(ToastMessages.ERROR_OCCURED_FETCH, {
        theme: ToastThemes.toastThemes.ERROR_OCCURED,
        header: ToastHeaders[ToastThemes.toastThemes.ERROR_OCCURED],
        duration: 3000,
      });
    }
  }, [props?.clientExpertRelation?.expertId, expertFetched, enqueueToast]);

  useEffect(() => {
    if (shouldFetchData(expertFetched)) fetchExpert();
  }, [expertFetched, fetchExpert]);

  function getContainerClasses() {
    if ([2, 3, 4].includes(props?.clientExpertRelation?.status))
      return 'element-container container-wrap open';

    return 'element-container open';
  }

  function getStatusClasses() {
    if (
      props?.clientExpertRelation?.status === quoteStatus.appointmentAchieved
    ) {
      if (clientContext?.clientExpertRelation?.clientSigned === 1)
        return waitingStatusClasses[props?.clientExpertRelation?.status + 1];
      if (clientContext?.clientExpertRelation?.clientSigned === -1)
        return waitingStatusClasses['-2'];
    }

    return waitingStatusClasses[props?.clientExpertRelation?.status];
  }

  function getStatusDetail() {
    if (
      props?.clientExpertRelation?.status === quoteStatus.appointmentAchieved
    ) {
      if (clientContext?.clientExpertRelation?.clientSigned === 1)
        return waitingStatusDetail.client[
          props?.clientExpertRelation?.status + 1
        ];
      if (clientContext?.clientExpertRelation?.clientSigned === -1)
        return waitingStatusDetail.client['-2'];
    }

    return waitingStatusDetail.client[props?.clientExpertRelation?.status];
  }

  return (
    <>
      <div className={getContainerClasses()} id={props?.id}>
        <div className="elements-data">
          {props?.clientExpertRelation?.status > 1 && (
            <div className="element-demand">
              <span className="data-title">Nom expert</span>
              <span className="data">{`${props?.clientExpertRelation?.expert?.firstName} ${props?.clientExpertRelation?.expert?.lastName}`}</span>
            </div>
          )}
          <div className="element-demand">
            {props?.clientExpertRelation?.status <= 1 ? (
              <span className="data-title">Devis numéro</span>
            ) : (
              <span className="data-title">Numéro dossier</span>
            )}
            <span className="data">
              #{props?.clientExpertRelation?.referenceNumber}
            </span>
          </div>
          <div className="element-amount">
            <span className="data-title">Montant estimé</span>
            <span className="data">
              {!props?.clientExpertRelation?.quote?.price ||
              parseInt(props?.clientExpertRelation?.quote?.price) === 0
                ? 'À déterminer lors du rendez-vous'
                : `${(props?.clientExpertRelation?.quote?.price / 12).toFixed(
                    2
                  )}€* HT/mois`}
            </span>
          </div>
          {props?.clientExpertRelation?.status > 1 && (
            <div className="element-amount">
              <span className="data-title">Date rendez-vous</span>
              <span className="data">
                {props?.appointment?.appointmentDate !== undefined
                  ? `${formatDate(
                      props?.appointment?.appointmentDate,
                      'DD.MM.YYYY'
                    )}-${formatDate(
                      props?.appointment?.appointmentDate,
                      'HH[h]mm'
                    )}`
                  : 'Aucune'}
              </span>
            </div>
          )}
          {props?.clientExpertRelation?.status <= 1 && (
            <div className="element-notation">
              <Notation rating={expert?.rating?.average} disabled={true} />
            </div>
          )}
          {props?.clientExpertRelation?.status !== quoteStatus.rejected && (
            <div className="element-statut">
              <span className="data-title">Statut</span>
              {
                <span className={`status-demand ${getStatusClasses()}`}>
                  {getStatusDetail()}
                </span>
              }
            </div>
          )}
        </div>
        <div className="element-details-open">
          <div className="element-expert-biography">
            <span className="expert-biography-title">
              Description de l'expert
            </span>
            <span className="expert-biography-content">
              {expert?.biography}
            </span>
          </div>
          {props?.clientExpertRelation?.status ===
            quoteStatus.expertAcceptClient && (
            <QuoteElementUserRdvModal data={props?.clientExpertRelation} />
          )}
          {props?.clientExpertRelation?.status >=
            quoteStatus.clientAcceptAppointment && (
            <QuoteElementExpertDetails expert={expert} />
          )}
          {(props?.clientExpertRelation?.status ===
            quoteStatus.appointmentAchieved ||
            props?.clientExpertRelation?.status === quoteStatus.rejected) &&
            props?.clientExpertRelation?.clientSigned === 0 && (
              <QuoteElementUserMissionModal
                clientExpertRelation={props?.clientExpertRelation}
              />
            )}
        </div>
      </div>
    </>
  );
}

export default QuoteElementUser;
